<template>
  <div>
    <Header />

    <div class="title-container">
      <h1>Logbooks</h1>

      <div class="filter-container">
      </div>
    </div>
    <div class="container-fluid-logbook">
      <vue-good-table :columns="columns" :rows="processedRows" :pagination-options="{ enabled: true, perPage: perPage }" :search-options="{ enabled: false }" 
      :sort-options="{ 
        enabled: true,     
        initialSortBy: [
          { field: 'project_id', type: 'asc' },
          { field: 'trainee_full_name', type: 'asc' }
        ] 
      }">
        <template #table-row="props">
          <!-- Product ID -->
          <span v-if="props.column.field === 'product_id'">
            <span :title="props.row.product ? props.row.product.name : 'Unknown'">
              {{ props.row.product_id }}
            </span>
          </span>
          <!-- Project ID -->
          <span v-else-if="props.column.field === 'project_id'">
            <span :title="props.row.project ? props.row.project.name : 'Unknown'">
              {{ props.row.project_id }}
            </span>
          </span>
          <!-- Trainee -->
          <span v-else-if="props.column.field === 'trainee_full_name'">
            <span>
              {{ props.row.trainee_full_name }}
            </span>
          </span>
          <!-- Instructors -->
          <span v-else-if="props.column.field === 'instructor_ids'">
            <span :title="props.row.instructor_names_display">
              {{ props.row.instructor_ids_display }}
            </span>
          </span>
          <!-- Status -->
          <span v-else-if="props.column.field === 'status'">
            <span
              :class="[
                'status-badge',
                props.row.status === 'inactive'
                    ? 'status-locked-badge'
                    : 'status-active-badge'
              ]"
            >
              {{ props.row.status === 'inactive' ? 'Locked' : 'Active' }}
            </span>
          </span>
          <!-- PDF Button -->
          <span v-else-if="props.column.field === 'pdf'">
            <button id="generatePDFButton" @click="openGeneratePDF(props.row)">PDF</button>
          </span>
          <!-- Progress Button -->
          <span v-else-if="props.column.field === 'progress'">
            <button id="traineeProgressButton" @click="openTraineeProgressModal(props.row)">Progress</button>
          </span>
          <!-- Actions -->
          <span v-else-if="props.column.field === 'actions'" class="center-icons">
            <font-awesome-icon icon="edit" class="edit-icon"
              :title="props.row.locked ? 'Logbook is locked' : 'Edit logbook'"
              @click="!props.row.locked && viewEditLogbook(props.row.logbook_id)"
              :class="{ 'disabled-icon': props.row.locked }" />

            <font-awesome-icon icon="trash-alt" class="delete-icon"
              :title="props.row.locked ? 'Logbook is locked' : 'Delete logbook'"
              @click="!props.row.locked && deleteLogbook(props.row)"
              :class="{ 'disabled-icon': props.row.locked }" />
          </span>
          <!-- Default Cell -->
          <span v-else :title="String(props.formattedRow[props.column.field] ?? '')">
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </div>
  </div>
  <div>
    <button class="btn btn-primary rounded" id=addlogbookButton @click="goAddLogbook">Create New Logbook</button>
  </div>

  <edit-logbook-modal v-if="showEditLogbook" @close="closeEditLogbook"></edit-logbook-modal>
  <GeneratePDF v-if="showGeneratePDF" :logbook-id="logbookId" :project="project" :selectedTrainee="selectedTrainee"
    :filteredTasks="mergedTasks" :logbookName="logbookName" @close="closeGeneratePDF"></GeneratePDF>
  <TraineeProgressModal v-if="showTraineeProgressModal" :logbookId="logbookId" :traineeId="selectedTraineeId"
    :mergedTasks="mergedTasks" @close="closeTraineeProgressModal"></TraineeProgressModal>
  <WithdrawLogbookModal v-if="withdrawingLogbook" :logbook="withdrawingLogbook"
    @close="withdrawingLogbook = null" @withdrawn="handleLogbookWithdrawn"></WithdrawLogbookModal>
</template>

<script>
import Header from '../Header.vue';
import axios from 'axios';
import { VueGoodTable } from 'vue-good-table-next';
import 'vue-good-table-next/dist/vue-good-table-next.css';
import EditLogbookModal from './EditLogbookModal.vue';
import GeneratePDF from '../../Instructor/InstructorLogbookReport.vue';
import TraineeProgressModal from '../../Trainee/TraineeProgressModal.vue';
import WithdrawLogbookModal from './WithdrawLogbookModal.vue';

export default {
  name: 'ViewLogbooks',

  components: {
    VueGoodTable,
    Header,
    EditLogbookModal,
    GeneratePDF,
    TraineeProgressModal,
    WithdrawLogbookModal,
  },

  data() {
    return {
      logbooks: [],
      perPage: 10,
      products: [],
      chapters: [],
      product: null,
      projects: [],
      project: null,
      users: [],
      instructors: [],
      tasks: [],
      mergedTasks: [],
      trainees: [],
      selectedProductId: '',
      selectedTraineeId: '',
      showEditLogbook: false,
      instructorNames: {},
      filteredLogbooksLength: 0,
      joinedName: '',
      selectedTrainee: [],
      showGeneratePDF: false,
      showTraineeProgressModal: false,
      logbookId: '',
      productId: '',
      logbookName: '',
      projectId: null,
      logbookEntries: [],
      withdrawingLogbook: null,
    };
  },
  computed: {
    columns() {
      return [
        { label: 'ID', field: 'logbook_id', sortable: true, thClass: 'vgt-id-column', tdClass: 'vgt-id-column' },
        {
          label: 'Logbook Name',
          field: 'name',
          sortable: true,
          thClass: 'vgt-logbook-name-column',
          tdClass: 'vgt-logbook-name-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterFn: (rowValue, filterValue) => {
              if (!filterValue) return true;
              return String(rowValue || '').toLowerCase().includes(String(filterValue).toLowerCase());
            }
          }
        },
        {
          label: `${this.$labels.product} ID`,
          field: 'product_id',
          sortable: true,
          thClass: 'vgt-foreign-id-column',
          tdClass: 'vgt-id-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterDropdownItems: this.uniqueProductOptions,
            filterFn: (rowValue, filterValue) => {
              if (!filterValue) return true;
              return String(rowValue) === String(filterValue);
            }
          }
        },
        {
          label: `${this.$labels.project} ID`,
          field: 'project_id',
          sortable: true,
          thClass: 'vgt-foreign-id-column',
          tdClass: 'vgt-id-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterDropdownItems: this.uniqueProjectOptions,
            filterFn: (rowValue, filterValue) => {
              if (!filterValue) return true;
              return String(rowValue) === String(filterValue);
            }
          }
        },
        { 
          label: 'Trainee', 
          field: 'trainee_full_name', 
          sortable: true, 
          thClass: 'vgt-multi-id-column', 
          tdClass: 'vgt-multi-id-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterFn: (rowValue, filterValue) => {
              if (!filterValue) return true;
              return String(rowValue || '').toLowerCase().includes(String(filterValue).toLowerCase());
            }
          }
        },
        {
          label: 'Instructor ID(s)',
          field: 'instructor_ids',
          sortable: false,
          thClass: 'vgt-multi-id-column',
          tdClass: 'vgt-multi-id-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterDropdownItems: this.uniqueInstructorOptions,
            filterFn: (rowValue, filterValue) => {
              if (!filterValue) return true;
              return Array.isArray(rowValue) && rowValue.includes(String(filterValue));
            }
          }
        },
        {
          label: 'Status',
          field: 'status',
          thClass: 'vgt-status-column',
          tdClass: 'vgt-status-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterDropdownItems: [
              { value: 'active', text: 'Active' },
              { value: 'inactive', text: 'Locked' },
            ],
            filterFn: (rowValue, filterValue) => {
              if (filterValue === '' || filterValue === null || filterValue === undefined) return true;
              return String(rowValue) === String(filterValue);
            }
          }
        },
        { label: 'Generate PDF', field: 'pdf', sortable: false, thClass: 'vgt-actions-column', tdClass: 'vgt-actions-column' },
        { label: 'Progress', field: 'progress', sortable: false, thClass: 'vgt-actions-column', tdClass: 'vgt-actions-column' },
        { label: 'Actions', field: 'actions', sortable: false, thClass: 'vgt-actions-column', tdClass: 'vgt-actions-column' }
      ];
    },
    uniqueProductOptions() {
      const usedProductIds = [...new Set(this.logbooks.map(lb => lb.product_id).filter(Boolean))];

      return usedProductIds.map(id => {
        const product = this.products.find(p => String(p.product_id) === String(id));
        return {
          value: String(id),
          text: product ? product.name : `${this.$labels.product} ${id}`
        };
      });
    },
    uniqueProjectOptions() {
      const usedProjectIds = [...new Set(this.logbooks.map(lb => lb.project_id).filter(Boolean))];

      return usedProjectIds.map(id => {
        const project = this.projects.find(p => String(p.project_id) === String(id));
        return {
          value: String(id),
          text: project ? project.name : `${this.$labels.project} ${id}`
        };
      });
    },
    uniqueInstructorOptions() {
      const usedInstructorIds = [...new Set(this.instructors.map(i => i.user_id).filter(Boolean))];

      return usedInstructorIds.map(id => {
        const instructor = this.instructors.find(i => String(i.user_id) === String(id));
        return {
          value: String(id),
          text: instructor
            ? `${instructor.last_name}, ${instructor.first_name}`
            : `Instructor ${id}`
        };
      });
    },
    processedRows() {
      return this.logbooks
        .map(lb => {
          const t = lb.trainee; // comes from backend eager load
          const last = t?.last_name || '';
          const first = t?.first_name || '';

          const product = this.products.find(
            p => String(p.product_id) === String(lb.product_id)
          );

          const project = this.projects.find(
            p => String(p.project_id) === String(lb.project_id)
          );

          const logbookInstructors = this.instructors.filter(
            ins => String(ins.logbook_id) === String(lb.logbook_id)
          );

          return {
            ...lb,
            product_name: product ? product.name : `Unknown ${this.$labels.product}`,
            project_name: project ? project.name : `Unknown ${this.$labels.project}`,
            status: project?.is_complete ? 'complete' : lb.locked ? 'inactive' : 'active',
            trainee_full_name: (last || first) ? `${last}, ${first}` : '',
            trainee_last_name: last,
            instructor_ids: logbookInstructors.map(ins => String(ins.user_id)),
            instructor_ids_display: logbookInstructors.map(ins => ins.user_id).join(', '),
            instructor_names_display: logbookInstructors.length
              ? logbookInstructors.map(ins => `${ins.last_name}, ${ins.first_name}`).join(' | ')
              : 'Unknown Instructor',
          };
        });
    }
  },
  methods: {
    getInstructorsForLogbook(logbookId) {
      // Filter the instructors array based on the logbook_id
      return this.instructors.filter(instructor => instructor.logbook_id === logbookId);
    },
    getTraineeName(id) {
      const t = this.users.find(tr => tr.user_id === id);
      return t ? t.last_name + ', ' + t.first_name : 'Unknown Trainee';
    },
    async deleteLogbook(logbook) {
      const id = logbook.logbook_id;
      if (!confirm('Are you sure you want to delete this Logbook?')) return;
      if (!confirm('This action will PERMANENTLY delete the Logbook from the database. Do you wish to continue?')) return;

      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      try {
        const response = await axios.delete(`/api/logbooks/${id}`, { headers });

        if (response.status === 200) {
          // await removeItemFromCacheByUrl(`/api/logbooks/${id}`);
          this.logbooks = this.logbooks.filter(a => String(a.logbook_id) !== String(id));
          window.alert('Logbook deleted successfully');
        }
      } catch (error) {
        if (error.isOffline === true && error.queued) {
          this.logbooks = this.logbooks.filter(a => String(a.logbook_id) !== String(id));
          alert('You are offline. The delete has been queued and will sync later.');
          return;
        }

        if (error.response?.status === 409) {
          // Logbooks with entries can only be withdrawn with a recorded reason (e.g. medical)
          if (confirm('This Logbook cannot be deleted because it contains one or more entries.\n\n'
            + 'If the trainee has left the course (e.g. for medical reasons), you can withdraw the Logbook instead. Do you want to withdraw it?')) {
            this.withdrawingLogbook = logbook;
          }
        } else {
          alert('An error occurred while deleting.');
        }
      }
    },
    handleLogbookWithdrawn(id) {
      this.logbooks = this.logbooks.filter(a => String(a.logbook_id) !== String(id));
      this.withdrawingLogbook = null;
    },
    async fetchTraineeTasks(traineeId) {
      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        console.log(traineeId);

        // Fetch trainee logbooks using trainee ID
        const traineeLogbooksResponse = await axios.get(`api/trainee/${traineeId}/logbooks`, { headers });
        const traineeLogbooks = traineeLogbooksResponse.data.logbooks; // Assuming it returns an array of logbooks

        console.log(traineeLogbooks);

        // Fetch tasks in each logbook
        const tasksPromises = traineeLogbooks.map(async (logbook) => {
          const logbookId = logbook.logbook_id;
          const logbookEntryResponse = await axios.get(`api/logbookentry/${logbookId}`, { headers });
          return logbookEntryResponse.data.tasks; // Assuming it returns an array of tasks for each logbook
        });

        const tasksArray = await Promise.all(tasksPromises); // Array of arrays of tasks

        // Flatten the tasksArray to a single array
        const tasks = tasksArray.flat();


        return tasks; // Return the tasks array
      } catch (error) {
        console.error('An error occurred while fetching trainee logbooks or tasks:', error);
        throw error; // Propagate the error to the calling code if needed
      }
    },
    async openGeneratePDF(logbook) {
      this.logbookId = logbook.logbook_id;
      this.logbookName = logbook.name;
      this.productId = logbook.product_id;
      this.projectId = logbook.project_id;

      this.fetchData(logbook, false);
    },
    closeGeneratePDF() {
      this.showGeneratePDF = false;
    },
    async openTraineeProgressModal(logbook) {
      this.logbookId = logbook.logbook_id;
      this.logbookName = logbook.name;
      this.productId = logbook.product_id;
      this.projectId = logbook.project_id;

      this.fetchData(logbook, true);
    },
    closeTraineeProgressModal() {
      this.showTraineeProgressModal = false;
    },
    async fetchData(logbook, isProgress) {
      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        const projectResponse = await axios.get(`/api/projects/${logbook.project_id}`, { headers });
        this.project = projectResponse.data.project;
        console.log('project', this.project);

        const traineeResponse = await axios.get(`/api/users/${logbook.trainee_id}`, { headers });
        this.selectedTrainee = traineeResponse.data;
        this.selectedTraineeId = traineeResponse.data.user_id;
        console.log('trainee', this.selectedTrainee);

        const tasksResponse = await axios.get(`/api/tasks/products/${logbook.product_id}`, { headers });
        this.tasks = tasksResponse.data;
        console.log('tasks', this.tasks);
        try {
          const inslogbookEntryResponse = await axios.get(`/api/logbookentry/${logbook.logbook_id}`, { headers });
          this.logbookEntries = inslogbookEntryResponse.data.tasks;
          console.log('logbookentries', this.logbookEntries);

        } catch (error) {
          if (error.response && error.response.status === 404) {
            this.logbookEntries = [];
            console.warn('No logbook entries found, continuing with empty entries.');
          } else {
            throw error;
          }
        }
        this.mergeData(isProgress);
      } catch (error) {
        console.error('An error occurred while fetching data:', error);
      }
    },
    mergeData(isProgress) {
      this.mergedTasks = this.tasks.map(task => {
        const matchingEntry = this.logbookEntries.find(entry => entry.task_id === task.task_id);

        const matchingInstructor = this.instructors.find(
          instructor => instructor.user_id === matchingEntry?.instructor_id
        );

        return {
          ...task,
          logbookentry_id: matchingEntry ? matchingEntry.id : null,
          completed: matchingEntry ? matchingEntry.completed : null,
          ins_so: matchingEntry ? matchingEntry.ins_so : null,
          enabled: matchingEntry ? matchingEntry.enabled === 1 : 0,
          troubleshoot: matchingEntry ? matchingEntry.troubleshoot : null,
          instructor_id: matchingEntry ? matchingEntry.instructor_id : null,
          ac_reg: matchingEntry ? (matchingEntry.ac_reg ?? matchingEntry.initial_ac_reg ?? '') : '',
          jobcard_no: matchingEntry ? matchingEntry.jobcard_no : null,
          is_selected: matchingEntry ? matchingEntry.is_selected : null,
          is_revoked: matchingEntry ? matchingEntry.is_revoked : null,
          t_signature_id: matchingEntry ? matchingEntry.t_signature_id : null,
          ins_signature_id: matchingEntry ? matchingEntry.ins_signature_id : null,
          instructor_name: matchingInstructor ? `${matchingInstructor.first_name} ${matchingInstructor.last_name}` : '',
          instructor_license: matchingInstructor ? matchingInstructor.license_no : ''
        };
      });

      this.completedMTCount = this.mergedTasks.filter(task => task.manob === 'MT' && task.completed).length;

      if (isProgress === true) {
        this.showTraineeProgressModal = true;
      } else {
        this.showGeneratePDF = true;
      }

      console.log('merged', this.mergedTasks);
    },
    goAddLogbook() {
      this.$router.push({ name: 'AddLogbook' })
    },
    viewEditLogbook(logbook) {
      this.selectedLogbook = logbook;
      this.showEditLogbook = true; // Show the modal when the button is clicked
    },
    closeEditLogbook() {
      this.showEditLogbook = false; // Close the modal
    },
    handleLogbookUpdated(updatedLogbook) {
      const index = this.logbooks.findIndex(
        lb => lb.logbook_id === updatedLogbook.logbook_id
      );

      if (index !== -1) {
        this.logbooks.splice(index, 1, {
          ...this.logbooks[index],
          ...updatedLogbook,
        });
      }

      this.closeEditLogbook();
    },
    async fetchChapters() {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
      try {
        const chapterResponse = await axios.get(`/api/chapters`, { headers });
        this.chapters = chapterResponse.data;
        console.log('chapters', this.chapters);
      } catch (error) {
        console.error(`Error fetching data for chapters:`, error);
      }
    },
  },
  async mounted() {
    try {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      let result = await axios.get('/api/logbooks', { headers });
      this.logbooks = result.data;
      console.log(this.logbooks);

      // Fetch all Products from the server
      const productResponse = await axios.get('/api/products', { headers });
      this.products = productResponse.data; // Assign the entire array of products to this.products

      let resultInstructors = await axios.get('/api/user/logbooks', { headers });
      this.users = resultInstructors.data.user_logbooks;
      console.log('response', resultInstructors.data.user_logbooks);
      // Filter only the instructors
      this.instructors = this.users.filter(user => user.role === 'instructor');
      console.log('instructors', this.instructors);

    } catch (error) {
      console.error('An error occurred while fetching data:', error);
    }
    this.fetchChapters();
  },

}
</script>


<style scoped>
.container-fluid-logbook {
  padding-top: 10px;
  width: 98%;
  margin-left: 1%;
  margin-right: 1%;
  display: flex;
  justify-content: center;
}

button.btn#addlogbookButton {
  padding: 10px 10px;
  font-size: 16px;
  width: 180px;
  height: 40px;
  margin-top: 0;
  margin-bottom: 15px;
  margin-right: 20px;
  border: 1px solid rgb(0, 96, 134);
  background: #2952c4;
  color: white;
  cursor: pointer;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
  float: right;
}

button.btn#addlogbookButton:hover {
  background-color: #0c1a61;
  transition: transform 0.2s, box-shadow 0.2s;
}

h1 {
  padding-top: 0px;
  padding-left: 3%;
}

label {
  margin-top: 8px;
}

.edit-icon {
  font-size: 16px;
  /* Adjust the size as needed */
  color: #615f5f;
  /* Change the color to your preference */
  cursor: pointer;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
}

.edit-icon:hover {
  color: #2b2a2a;
  /* Change the color to your preference */
  cursor: pointer;
  transform: scale(1.1);
  /* Example transform for scaling on hover */

}

.delete-icon {
  font-size: 16px;
  color: #FF0000;
  /* Red color */
  cursor: pointer;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
  padding-left: 15px;
}

.delete-icon:hover {
  color: #a82222;
  /* Lighter red color on hover */
  cursor: pointer;
  transform: scale(1.1);
  /* Scale the icon on hover */
  /* You can also add a box-shadow or any other styles you prefer */
}

input {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  width: 200px;
}

select {
  padding: 5px;
  border-radius: 5px;
  font-size: 16px;
  width: 200px;
}

button#generatePDFButton {
  border-radius: 5px;
  background-color: #c8e1fa;
  font-size: 13px;
  padding: 5px;
  width: 40px;
  border: 1px solid #1c4e80;
}

button#generatePDFButton:hover {
  background-color: #b4d7fa;
  cursor: pointer;
}

button#traineeProgressButton {
  border-radius: 5px;
  background-color: #c1f5bb;
  font-size: 13px;
  padding: 5px;
  width: 60px;
  border: 1px solid #366131;
}

button#traineeProgressButton:hover {
  background-color: #aff5a8;
  cursor: pointer;
}

button#openLogbookButton {
  border-radius: 5px;
  background-color: #faf0c8;
  font-size: 13px;
  padding: 5px;
  width: 45px;
  border: 1px solid #646400;
}

button#openLogbookButton:hover {
  background-color: #f7e7a7;
  cursor: pointer;
}

input:disabled,
button:disabled {
  cursor: not-allowed;
  border: 1px solid #ddd;
  opacity: 0.5;
  transition: none;
  transform: none;
}

.delete-icon.disabled-icon,
.edit-icon.disabled-icon {
  pointer-events: auto;
  cursor: not-allowed;
  opacity: 0.5;
  filter: grayscale(100%);
}

.status-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px !important;
  color: #fff;
}

/* Locked = red */
.status-locked-badge {
  background: #dc3545;
}

/* Active = green */
.status-active-badge {
  background: #28a745;
}

.status-completed-badge {
  background: #398dec;
}

/* Optional hover effect (like your pending badge) */
.status-badge:hover {
  opacity: 0.9;
  cursor: default; /* or pointer if clickable */
  color: white !important;
}
</style>